import styled from '@emotion/styled';
import type { PropsWithChildren } from 'react';
import { colors } from '@/constants/colors';

export type ChipStyles = {
  backgroundColor?: string,
  textColor?: string,
  fontSize?: string,
  fontFamily?: string,
  bold?: boolean,
  height?: string,
  size?: 'normal' | 'small' | 'wide',
  minWidth?: string,
  width?: string,
  border?: string,
  padding?: string,
};

interface ChipProps extends ChipStyles {
  txt?: string;
}

const ChipWrapDiv = styled.div<ChipStyles>`
display: grid;
width: ${({ width = 'fit-content' }) => width};
min-width: ${({ minWidth, size }) => {
    if (minWidth) return minWidth;
    switch (size) {
      case 'wide': return '66px';
      case 'normal': return '50px';
      default: return '0';
    }
  }};
height: ${({ height, size }) => height ? height : size === 'small' ? '20px' : '26px'};
padding: ${({ padding, size }) => {
    if (padding) return padding;
    return `4px ${size === 'wide' ? '13px' : '6px'}`;
  }};
border: ${({ border }) => border ?? '0 solid transparent'};
background-color: ${({ backgroundColor }) => backgroundColor};
border-radius: 4px;
font-family: ${({ fontFamily }) => fontFamily};
font-size: ${({ fontSize, size }) => fontSize ? fontSize : size === 'small' ? '9px' : '12px'};
line-height: 100%;
place-items: center;
white-space: nowrap;
`;

const ChipTxtSpan = styled.span<ChipStyles>`
color: ${({ textColor }) => textColor ?? colors.white};
font-weight: ${({ bold }) => bold ? '700' : '500'};
`;

const Chip = ({
  children,
  txt,
  ...chipStyles
}: PropsWithChildren<ChipProps>) => (
  <ChipWrapDiv
    tabIndex={-1}
    {...chipStyles}
  >
    {txt && <ChipTxtSpan {...chipStyles}>{txt}</ChipTxtSpan>}
    {children}
  </ChipWrapDiv>
);

export default Chip;
